import React, { useState } from 'react'
import MaterialTable from "@material-table/core";
import { withTranslation } from 'react-i18next'
import PreviewTransaction from './components/PreviewTransaction'
import Filter from 'components/Filter'
import { useDispatch } from 'react-redux'
import { previewModal } from 'store/slices/miscSlice'
import useTransaction from 'hooks/useTransaction'
import HeaderFilterExport from 'components/HeaderFilterExport'
import { Transcontext } from './context'
import Status from 'components/Status';
import ViewMoreBtn from 'components/viewMoreBtn';
import usePermissions from 'hooks/usePermissions';
import Spinner from 'components/Spinner';
import { useEffect } from 'react';
import { CSV } from 'components/CSV';
import TablePaginationDemo from 'components/Paginator';
import { useLocation } from 'react-router-dom';
import styles from './transaction.module.css'

export default withTranslation()(function Transaction({ t }) {

  const [params, setParams] = useState(window.location.search)
  const path = useLocation()
  useEffect(() => {
    setParams(param => path?.search.substring(1, path?.search.length))
    console.log(path?.search)
  }, [path])
  const { transactions, ...misc } = useTransaction(params)

  const head = ['Customer Name', 'Amount paid', 'Phone', 'Reference', 'Payment method', 'Date', 'Branch', 'Teller', 'Gross Amount', 'Reward earned', 'Reward redeemed', 'Fee']
  const rest = transactions ? transactions?.map(trans => [trans?.username,
  trans?.net_amount, trans?.phone, trans?.reference, trans?.payment_mode,
  trans?.date, trans?.branch, trans?.teller, trans?.formatted_gross_amount, trans?.reward_earned, trans?.reward_used, trans?.fee]
  ) : []
  const csvData = [head, ...rest]
  const dispatch = useDispatch()
  const [open, setOpen] = useState(0)
  const [innerOpen, setInnerOpen] = useState(false)
  const { isPermitted } = usePermissions(['view_all_transactions', 'view_totasl_transactions'])

  const columns = [
    { title: t('transaction.table.CustomElementRegistry'), field: 'username', id: 'customer_name' },
    { title: t('transaction.table.amount'), field: 'formatted_gross_amount', id: 'amount' },
    { title: t('transaction.table.net_amount'), field: 'net_amount', id: 'net_amount' },
    { title: t('transaction.table.payment_method_header'), field: 'payment_mode', id: 'payment_mode' },
    {
      title: t('misc.status'), field: 'status', id: 'status',
      render: ({ status }) => {
        return (status === 'completed' ? <Status text={status} color={'#34C759'} bg={'#34C7591A'}  /> : (
          status === 'pending' ? <Status text={status} color={'#F2994A'} bg={'#F2994A1A'} /> :
            <Status text={status} color={'#FF3B30'} bg={'#FF3B301A'} />)
        )
      }
    },
    {
      title: t('transaction.table.date'), field: 'created_at', id: 'created_at',
      render: ({ created_at }) => <span className="">{created_at}</span>
    }
  ]
  return (
    <Transcontext.Provider value={{ open, innerOpen, setOpen, setInnerOpen }}>
      <div className={"bg-white rounded-xl p-5 "+ styles.transactions}>
        <HeaderFilterExport
          title={t('transaction.table.title')}
          options={[
            {
              name: t('settlements.table.filter'),
              Content: () => <Filter />,
              click: 'filter'
            },
            {
              name: t('transaction.table.export_csv'),
              Content: () => <CSV fileName='transactions.csv' csvData={csvData} />,
              click: 'export'
            }
          ]} />
        {transactions ? <MaterialTable
        
          columns={columns}
        
          actions={[
            {
              icon: 'save',
              tooltip: 'Save User',
            },
          ]}
          localization={{
            header: {
              actions: "",
            },
            body: {
              emptyDataSourceMessage: misc.isLoading ? <Spinner /> : 'No transactions to display',
              
            }
          }}
          onRowClick={(_,data)=>{
            dispatch(previewModal({
              title: `${t('transaction.preview_title')}`,
              content: () => <PreviewTransaction tableProps={data} />
            }))
          }}
          options={{
            rowStyle:{
              cursor:'pointer'
            },
            actionsColumnIndex: -1,
            headerStyle: {
              color: "#657585",
              fontWeight: 700,
              fontFamily: 'Helvetica Neue',
              lineHeight: '21px',
              fontSize: '14px'
            },
            actionsCellStyle: { width: '10px' },
            search: false,
            toolbar: false,
            pageSize: misc.per_page,
            emptyRowsWhenPaging: false,
            // pageSizeOptions: [5, 10, 15, 20, 25, 30],
            // paging: true
          }}

          data={
            (transactions && isPermitted?.view_all_transactions) ? transactions : []
          }
          components={{
            Action: ({ data }) => (
              <ViewMoreBtn click={() => {
                dispatch(previewModal({
                  title: `${t('transaction.preview_title')}`,
                  content: () => <PreviewTransaction tableProps={data} />
                }))
              }} />
            ),
            
            Pagination: ({ data }) => (<TablePaginationDemo {...misc} />)
          }}
        /> : <Spinner />}
      </div>
    </Transcontext.Provider >
  )
})